// This function transforms the data from the CDA so it matches how the old content delivery api would return the data
// It is referenced in pageContentConnector so the transformation takes place serverSide through getStaticProps

export const legacyTransform = (rawData) => {
	// Step 1: Sort items based on the path in the route to create parent-child relationships.
	const children = [];
	rawData.forEach((item) => {
		const { contentType, name, properties } = item;

		// Determine how to categorize the item based on contentType
		if (contentType === 'comparisonSubjects') {
			const comparisonSubjects = {
				documentType: 'comparisonSubjects',
				children: [],
			};

			// Add to comparisonGroupFolder children if it's a subject
			children.push(comparisonSubjects);
		}
		if (contentType === 'comparisonSubject') {
			const comparisonSubject = {
				documentType: 'comparisonSubject',
				name,
				children: [],
			};

			// Add the subject to the appropriate subjects group
			const parentSubject = children.find((subject) => subject.documentType === 'comparisonSubjects');
			if (parentSubject) {
				parentSubject.children.push(comparisonSubject);
			}
		}
		if (contentType === 'comparisonSubjectItem') {
			const comparisonSubjectItem = {
				id: item.id,
				properties: properties,
			};

			// Attach the item to the appropriate subject
			const parentSubject = children.find((subject) => subject.documentType === 'comparisonSubjects');
			if (parentSubject) {
				const subject = parentSubject.children[parentSubject.children.length - 1]; // Assume it's the last added subject
				if (subject) {
					subject.children.push(comparisonSubjectItem);
				}
			}
		}
		if (contentType === 'comparisonIdentifiers') {
			const comparisonIdentifiers = {
				documentType: 'comparisonIdentifiers',
				name,
				children: [],
			};

			// Add to comparisonGroupFolder children if it's an identifier group
			children.push(comparisonIdentifiers);
		}
		if (contentType === 'comparisonIdentifier') {
			const comparisonIdentifier = {
				documentType: 'comparisonIdentifier',
				name,
				properties,
			};
			const parent = item.route.path.split('/').slice(-2, -1)[0];

			// Attach the identifier to the appropriate identifiers group
			const parentIdentifiers = children.find((identifier) => identifier?.name?.toLowerCase() === parent.toLowerCase());
			if (parentIdentifiers) {
				parentIdentifiers.children.push(comparisonIdentifier);
			}
		}
	});

	return children.map((group) => {
		if (group.documentType !== 'comparisonIdentifiers') return group;
		return {
			...group,
			children: group?.children?.map((comparisonIdentifier) => {
				const comparisonIdentifierItems = comparisonIdentifier.properties.items.items.map((comparisonIdentifierItem) => {
					let subjectLabelData;
					const comparisonSubjects = children.find((x) => x.documentType === 'comparisonSubjects');
					comparisonSubjects?.children?.forEach((subjectGroup) => {
						subjectGroup.children.find((subject) => {
							if (subject.id === comparisonIdentifierItem.content.properties.subjectLabel[0].id) {
								subjectLabelData = subject;
								return true;
							}
						});
					});
					return {
						content: {
							...comparisonIdentifierItem.content,
							properties: {
								...comparisonIdentifierItem.content.properties,
								subjectLabel: subjectLabelData,
							},
						},
					};
				});
				return {
					...comparisonIdentifier,
					properties: {
						items: comparisonIdentifierItems,
					},
				};
			}),
		};
	});
};
